<template>

    <!-- Page Sidebar Ends-->
     <div class="container-fluid front_header">
            <div class=" ">
              <div class="row">
                <div class="col-12">
                   <img class="img-fluid for_logo" src="../../../assets/images/logo/logo.png"
                                    alt="looginpage">
                </div>
              </div>
            </div>
          </div>
          <div class="page-body">
      
        <div class="container-fluid">
            <div class="user-profile social-app-profile">
            

                <div class="tab-pane fade show active" id="about" role="tabpanel" aria-labelledby="about">
                    <div class="row mb-5">
                      <div class="col-xl-12 xl-40 col-lg-12 col-md-5 box-col-4">
                        <div class="default-according style-1 faq-accordion" id="accordionExample">
                          <div class="card">
                           
                            <div class="card">
                                <div class="card-body socialprofile filter-cards-view">
                          
                                    <div class="row align-items-center">
                                      <div class=" text-center">
                                        <div @click="visitorprofile" v-if="user.photo">
                                        <img class="img-100 img-fluid m-r-20 rounded-circle" :src="getImageUrl(user.photo)" alt="" >
                                        </div>
                                          <div v-else>
                                          <img class="img-100 img-fluid m-r-20 rounded-circle" :src="getImageUrl(user.photo)" alt="" @click="uploadphoto"><br>
                                          <span class="text-danger">please upload image</span>
                                          </div>
                                      </div>
                             
                                      <div class="mt-4">

                                       
                                        <!--<span class="d-block">Full Name:</span>-->
                                      
                                        <h5>
                                        
                                          <div class="form-group">
                                            <span class="col-form-label">Name</span>
                                            <input class="form-control" type="text" v-model="user.name"
                                                placeholder="Type Here..." required="" :readonly="isName">
                                        </div>
                                        </h5>

                                        <div class="form-group">
                                          <span class="col-form-label">Firm Name</span>
                                          <input class="form-control" type="text" v-model="user.firmname"
                                              placeholder="Type Here..." required=""    :readonly="isFirmName">
                                      </div>

                                      <div class="form-group">
                                        <span class="col-form-label"> Address</span>
                                        <input class="form-control" type="text" v-model="user.address"
                                            placeholder="Type Here..." required="" :readonly="isAddress">
                                    </div>


                                    <div class="form-group">
                                      <span class="col-form-label"> Designation</span>
                                      <input class="form-control" type="text" v-model="user.designation"
                                          placeholder="Type Here..." required="" :readonly="isDesignation">
                                  </div>

                            <div class="form-group">
                                    <label class="col-form-label">Adhaar Card</label>
                                    <input class="form-control" type="file"  @change="handleFileUpload"  ref="fileInput"  
                                        required=""  style="display: none;" :disabled="isAdhar">       
                                </div>


                                <div v-if="user.aadharcard">
                                  <img :src=" imageUrls || this.$hostname+'writable/uploads/aadhar_card/'+user.aadharcard"  @click="triggerFileInput" alt="Uploaded Image" style="height: 80px; width: 80px;" />
                                 </div>
                                 <div v-else="user.aadharcard == null ">
                                  <img :src=" imageUrls || this.$hostname+'writable/visitors/user.png'"  @click="triggerFileInput" alt="Uploaded Image" style="height: 80px; width: 80px;" />
                                  </div>


                                  <div class="text-end mt-3">
                                    <button class="btn btn-primary btn-block w-100" @click="saveData">Update</button>
                                </div>


                                        
                                      </div>
                                    </div>
                                 
                              
                                  <div class="likes-profile text-center mt-3">
                                    <h5>
                                      <span>
                                        <i class="fa fa-heart font-danger"></i> {{visits.length}}
                                      </span>
                                    </h5>
                                    <div>Times You Visited HD Hyundai</div>
                                  </div>
                              
                                  <div class="text-center mt-3">
                                    <button class="btn btn-danger" @click="logout">Logout</button>
                                  </div>
                                </div>
                              </div>
                              
                          </div>
                         
                        </div>
                      </div> 
                     
                    </div>
                  </div>
          



                    
            </div>
          </div>



    </div>  
    
    
    <div class="fixed-bottom bg-light border-top shadow-sm">
      <div class="d-flex justify-content-around text-center py-2">
        <router-link to="/visitorpage" class="text-decoration-none text-dark">
          <div><i class="fa fa-home fa-lg"></i></div>
          <small>Home</small>
        </router-link>
        <router-link to="/ActivePage" class="text-decoration-none text-dark">
          <div><i class="fa fa-bolt fa-lg"></i></div>
          <small>Active</small>
        </router-link>
        <router-link to="/PastPage" class="text-decoration-none text-dark">
          <div><i class="fa fa-history fa-lg"></i></div>
          <small>Past</small>
        </router-link>
       <router-link to="/ProfilePage" class="text-decoration-none text-dark">
          <div><i class="fa fa-user fa-lg"></i></div>
          <small>Profile</small>
        </router-link>
       <a @click="creategatepass" class="text-decoration-none text-dark">
          <div><i class="fa fa-plus-circle fa-lg"></i></div>
          <small>Create</small>
        </a>
      </div>
    </div>

    <span @click="creategatepass" type="button" class="btn  btn-pill btn-secondary createbtn">Create Gatepass</span>


</template>
<style scoped>
.createbtn{
  position: fixed;
    right: 0;
    bottom: 0;
    z-index: 999;
}
.page-body{
    margin-left: 0 !important;
    margin-top: 0px!important;
}
.user-profile .hovercard .cardheader{
        height: 70px;
        background: linear-gradient(45deg, #0437c8, #007611);
    }
    @media only screen and (max-width: 575.98px) {
      .tabs-scoial li:nth-child(3) {
          position: sticky;
      }
      .user-profile .hovercard .info{
          padding: 10px;
      }
      .tabs-scoial{
          padding-top: 60px;
      }
    }
.checkin{
  background: #d4ffb4;
}
.checkout{
  background: #dbd7ff;
}
.noinfo-container {
  text-align: center; /* Center the span horizontally */
}
.noinfo{
  text-align: center;
  font-weight: bold; 
}
.info{
    font-weight: bold;
    color: black;
}

 .rounded-circle{
     height: 130px;
    width: 130px !important;
 }
</style>

<script>
// @ is an alias to /src 
import PageTitle from '@/components/PageTitle.vue'; 
// import axios from 'axios';
import axios from "@/plugins/axios";
import QRCode from 'qrcode';
const config = {
            headers: {
               "Content-Type": "application/x-www-form-urlencoded"
            },
            responseType: 'json'
         };
export default {
    name: 'VisitorPage', 
    components: {
        PageTitle 
    }, 
    mounted() {
             
        this.getBasics();



        }, 
        data() {
        return {
          //user: { "name": '', "firmname": '',"contact": '', "purpose": ''},
            visits: [],
            accessories:[],
            addAccessories_passid:'',
            accessories_name:'',
            past_visits:[],
            
            user:{
            name: '',
            firmname: '',
            address: '',
            designation:'',
        },
            imageUrls: null,  
            isName:false,
            isFirmName:false,
            isAddress:false,
            isDesignation:false,
            isAdhar:false,
        }
    },
    methods: {  

        getBasics(token,isLocalToke=0) {
            var self = this;
            axios.post('getVisitorProfile').then(function (response) {
                
              if(response.data.is==1){
                localStorage.removeItem('_emp_token');
                self.user = response.data.user; 
                
                if(self.user.name)
                    self.isName=true;
                if(self.user.firmname)
                    self.isFirmName=true;
                if(self.user.address)
                    self.isAddress=true;
                if(self.user.designation)
                    self.isDesignation=true;
                if(self.user.aadharcard)
                    self.isAdhar=true;
                
                
                
                
                
                
                if(self.user.name=='')
                    self.$router.push({ name: "visitorprofile" });   
                    
                self.visits = response.data.visits;  
                self.past_visits = response.data.past_visits;  
                window.scrollTo(0, 0);
              }else if(response.data.is==0){
                localStorage.removeItem('token');
                self.$router.push({ name: "register" });   
              }
              

                
            });
        },
        
       
        checkOutRequest(token) {
            var self = this;
            axios.post('checkOutRequest',{token:token}).then(function (response) {
              if(response.data.is==1){ 
                self.$swal(response.data.msg);
                window.scrollTo(0, 0);
              }  });
        },
        add_accessories(token) {
            var self = this;
            axios.post('addGatePasAccessories',{token:localStorage['token'],accessories_passid:this.addAccessories_passid,accessories_name:this.accessories_name}).then(function (response) {
              if(response.data.is==1){ 
                self.accessories = response.data.accessories; 
                window.scrollTo(0, 0);
              }  });
        },
        getImageUrl(image) {
            if(image && !image.includes('.bin'))
                return `${this.$hostname}/writable/uploads/visitors/${image}`;
            else
                return `${this.$hostname}/writable/visitors/user.png`;
            },
            
        async getQrCode(token) {
            try {
              if(token.length>0){
                  const canvas = this.$refs.qrcodeCanvas;
                  var url=this.$api_host+'vp?q='+token;
                  //var url= 'http://192.168.1.8:8081/visitorgatepassview?q='+token;
                  await QRCode.toCanvas(canvas,url , { width: 200 });
                  $("#qrcodeView").modal("toggle");
              }
              
            } catch (error) {
              console.error(error);
            }
          }, 
          addAccessories_modal(visit) {
             this.addAccessories_passid=visit.gatepassid;
             if(this.addAccessories_passid>0){
              var self = this;
              axios.post('getAccessories',{token:localStorage['token'],accessories_passid:this.addAccessories_passid,accessories_name:this.accessories_name}).then(function (response) {
                if(response.data.is==1){ 
                    self.accessories = response.data.accessories; 
                    $("#accessoriesModal").modal("toggle");
              }  });
                
                
                 
             }
           
          },
          logout(){
            localStorage.removeItem('token');
            localStorage.removeItem('_emp_token');
            this.$router.push({ name: "register" });  
          },

          saveData() {
    const self = this;
    if (self.user.name.length == 0) {
        self.$swal("Please Enter Name");
    } else if (self.user.address.length == 0) {
        self.$swal("Please Enter Address");
    } else {
        // Create FormData object
        const formData = new FormData();
     
        
        // Append all user data to formData
        formData.append('name', self.user.name);
        formData.append('firmname', self.user.firmname);
        formData.append('address', self.user.address);
        formData.append('designation', self.user.designation);
        formData.append('photo', self.user.photo);
        // Append any other fields from self.user
        
        // Append the file if it exists
        if (self.user.file) {
            formData.append('file', self.user.file);
        }
        
        axios.post('saveProfile', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(function(response) {
            if(response.data.is == 1) { 
                self.$swal({
                    title: "Successfull",
                    text: "Profile Update Done",
                    type: "warning", 
                }) ;
            } else {
                self.$swal("Please Try Again");
            }
            window.scrollTo(0, 0);
        });
    }
},

    handleFileUpload(event) {
    const file = event.target.files[0];
    this.user.file = file;
    
    if (file) {
        this.imageUrls = URL.createObjectURL(file);
    }
},

  triggerFileInput() {
      if (this.$refs.fileInput) {
        this.$refs.fileInput.click();
      } else {
        console.warn("File input ref not found!");
      }
    },
    visitorprofile(){ 
            this.$router.push({ name: "capture" });   
        },  

        uploadphoto(){
          this.$router.push({ name: "capture" }); 
        },
        creategatepass(){
        //   window.location.assign(window.location.origin + "/visitorcreategatepass");
      
            if(this.user.photo && !this.user.photo.includes('.bin'))
                this.$router.push({ name: "visitorcreategatepass" }); 
            else
                this.$router.push({ name: "capture" });   
        },
       
    }
}





</script>
